import withRoom from '../hoc/withRoom';
import DetailPage from '../pages/Detail';

const Detail = withRoom(DetailPage);

export default Detail;
